import React from "react";

const CopyAndSaveReminder = () => {
  return (
    <div className="ask-litcharts-ai--message">
      <div className="body-2 notice">
        <strong>Important: </strong>
        Copy and save this response. It will disappear if you refresh or leave
        this page.
      </div>
    </div>
  );
};

export default CopyAndSaveReminder;
